import request from "@utils/request";

export function getOptions(type) {
        return request({
        url: 'alert/config/option/'+type,
        method: 'get',
    })
}

